jQuery(document).ready(function ($) {
  // vlastní select Select2 ( https://select2.org/ )
  if ($('.mu-js-select').length) {
    $('.mu-js-select').select2({
      language: 'cs',
    });
  }

  // select - vybraná položka
  if ($('.mu-js-select-selected').length) {
    $('.mu-js-select-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      width: 'resolve',
    });
  }

  // select - položka s vyhledáváním
  if ($('.mu-js-select-search').length) {
    $('.mu-js-select-search').select2({
      language: 'cs',
      dropdownCssClass: 'has-search',
      width: 'resolve',
    });
  }

  // select - vybraná položka s vyhledáváním
  if ($('.mu-js-select-search-selected').length) {
    $('.mu-js-select-search-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      dropdownCssClass: 'has-search',
      width: 'resolve',
    });
  }

  // select - řešení multiple selectu
  if ($('.mu-js-select-multi').length) {
    $('.mu-js-select-multi').on('change', function () {
      var selectActual = $(this).val();
      var selectConnect = '#' + $(this).data('multi');
      $(selectConnect + ' option[value="' + selectActual + '"]').prop(
        'selected',
        true
      );
      // nastavení stránkování na 1
      $('#strana').val(1);
      // odeslání formuláře
      $('#sbirky').submit();
    });
  }

  // select - datum se sliderem
  if ($('.mu-js-date-slider').length) {
    $('.mu-js-date-slider .mu-select-false__input').on('click', function () {
      $(this).next('.mu-slider').toggleClass('is-open');
    });
  }

  // select - odeslání formuláře sbírky po změně
  $('.mu-js-submit-collection').on('change', function () {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // select - odeslání formuláře kolekce po změně
  $('.mu-js-submit-collist').on('change', function () {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#collist').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-select').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-input').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - stránkování
  $('.mu-js-form-page').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.mu-js-form-checkbox').on('change', function () {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = '0';

    if ($(this).prop('checked')) {
      inputValue = '1';
    }

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // vlastní slider
  if ($('#mu-slider').length) {
    // hodnoty z data atributů
    var sliderMin = $('#mu-slider').data('min');
    var sliderMax = $('#mu-slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#mu-slider').data('mins');
    var sliderMaxSelected = $('#mu-slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    var slider = document.getElementById('mu-slider');

    noUiSlider.create(slider, {
      start: [sliderMinSelected, sliderMaxSelected],
      connect: true,
      step: 1,
      range: {
        min: sliderMin,
        max: sliderMax,
      },
    });

    var dateValues = [
      document.getElementById('mu-slider-min'),
      document.getElementById('mu-slider-max'),
    ];

    // aktualizace hodnot v inputech
    slider.noUiSlider.on('update', function (values, handle) {
      dateValues[handle].value = Math.ceil(values[handle]);
    });

    // odeslání formuláře po tažení
    slider.noUiSlider.on('set', function (values, handle) {
      sliderChecker();
    });
  }

  // odeslání formuláře po ruční změně
  $('#mu-slider-min').on('change', function () {
    sliderChecker();
  });
  $('#mu-slider-max').on('change', function () {
    sliderChecker();
  });

  // řešení odeslání formuláře po změně hodnot slideru
  function sliderChecker() {
    // hodnoty z data atributů
    var sliderMin = $('#mu-slider').data('min');
    var sliderMax = $('#mu-slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#mu-slider').data('mins');
    var sliderMaxSelected = $('#mu-slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    // nastavení stránkování na 1
    $('#strana').val(1);

    // hodnoty do skrytých polí (pro porovnání)
    var sliderMinActual = dateValues[0].value;
    var sliderMaxActual = dateValues[1].value;
    if (sliderMinSelected != sliderMinActual) {
      $('#datfset').val(sliderMinActual);
    }
    if (sliderMaxSelected != sliderMaxActual) {
      $('#dattset').val(sliderMaxActual);
    }

    // odeslání formuláře
    $('#sbirky').submit();
  }
});


//# sourceMappingURL=scripts.js.map
